import React from "react";

import { Divider } from "@mui/material";

import { SettingsModuleProps } from "@app/analytics/account/types";
import SliderHeading from "@app/analytics/account/WorkspaceSettings/components/SliderHeading";
import WorkspaceSettingsAccordion from "@app/analytics/account/WorkspaceSettings/components/WorkspaceSettingsAccordion";
import {
  EnterpriseWorkspaceSettings,
  EnterpriseWorkspaceSettingUpdateConfig,
} from "@app/common/workspaces/types";

import WorkspacePermissionItem from "../components/WorkspacePermissionItem";

const ROLL_UP_OPTIONS: {
  title: string;
  name: keyof EnterpriseWorkspaceSettings;
  subtitle: string;
  recommendation: { value: string; description: string };
  tooltip?: string;
}[] = [
  {
    title: "Workspace Trends",
    name: "workspaceRollups",
    subtitle: "Can view aggregate metrics and trends for the Workspace.",
    recommendation: {
      value: "User",
      description: "Gives all users in Workspace access",
    },
    tooltip:
      "This includes the ability to view meeting policy and dashboard reports generated at the workspace-level (no individuals).",
  },
  {
    title: "Team Trends",
    name: "teamRollups",
    subtitle: "Can view aggregate metrics and trends for their team(s).",
    recommendation: {
      value: "Manager",
      description: "Gives managers access to reports for their Team",
    },
    tooltip:
      "This includes the ability to view meeting policy and dashboard reports generated at the team-level (no individuals).",
  },
];

const MeetingReportsModule = ({
  onSettingUpdate,
  settings,
  workspaceIsInactive,
}: SettingsModuleProps) => {
  return (
    <WorkspaceSettingsAccordion
      title="Aggregate Metrics & Trends"
      subtitle="Customize which roles have access to aggregate reporting within your Workspace"
    >
      <SliderHeading />
      {ROLL_UP_OPTIONS.map((option, i) => {
        const settingForOption = settings[
          option.name
        ] as EnterpriseWorkspaceSettingUpdateConfig;

        return (
          <React.Fragment key={option.name}>
            {i > 0 && <Divider />}
            <WorkspacePermissionItem
              disabled={workspaceIsInactive}
              {...option}
              onSettingUpdate={onSettingUpdate}
              setting={settingForOption}
            />
          </React.Fragment>
        );
      })}
    </WorkspaceSettingsAccordion>
  );
};

export default MeetingReportsModule;
